import { Page } from "../page";

export class AllocationConstraintInboundRequest extends Page{
    facility: string | null;
    storer: string | null;
    brand: string | null;
    sku: string | null;
    checkTypes: string[] | [];
    activeFlag: string | null;

    constructor(){
        super();
        this.facility = null;
        this.storer = null;
        this.brand = null;
        this.sku = null;
        this.checkTypes = [];
        this.activeFlag = null;
    }
}
